import { render, staticRenderFns } from "./staffDepartDetail.vue?vue&type=template&id=7165150b&scoped=true&"
import script from "./staffDepartDetail.vue?vue&type=script&lang=js&"
export * from "./staffDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffDepartDetail.vue?vue&type=style&index=0&id=7165150b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165150b",
  null
  
)

export default component.exports